<footer>
  <div class="container-fluid ms-0">
    <div class="row">
      <div class="col-sm-4">
        © 2025 EXL. All rights reserved.
      </div>
      <div class="col-sm-8 text-sm-end">
        <nav>
          <div class="d-flex justify-content-end">
            <div class="me-3">
              <a href="https://www.exlservice.com/terms-of-use" target="_blank">Terms of Use</a>
            </div>
            <div class="me-3">
              <a href="https://www.exlservice.com/privacy-policy" target="_blank">Exl Privacy Policy</a>
            </div>
            <div>
              <a href="https://www.exlservice.com/legal-disclaimer" target="_blank">Legal Disclaimer</a>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</footer>
